import "./CareServices.module.css";
import Header from "@/reusable_sections/Header";
import PersonalizedCare from "./sections/PersonalizedCare";
import ADayInTheLife from "./sections/ADayInTheLife";
import HealthSafety from "./sections/HealthSafety";
import Footer from "@/reusable_sections/Footer";
export default function CareServicesPage() {
  return <div>
      <Header />
      <PersonalizedCare />
      <ADayInTheLife />
      <HealthSafety />
      <Footer />
    </div>;
}